import { Component, OnInit, Injector, ViewChild, ElementRef } from '@angular/core';
import { SecondPageEditBase, UserService, ValidationSummaryComponent } from 'sv-shared';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent extends SecondPageEditBase implements OnInit {

  invalid = false;
  invalid1 = false;
  formGroup1: FormGroup = new FormGroup({});
  @ViewChild('formElement1') formElement1: ElementRef;


  constructor(
    protected _userService: UserService,
    protected _injector: Injector,

  ) {
    super(_userService, _injector);
  }

  @ViewChild('validationSummary') _validationSummaryComponent: ValidationSummaryComponent;
  ngAfterViewInit() {
    this.validationSummary = this._validationSummaryComponent;
  }

  ngOnInit() {
    this.formGroup = new FormGroup({
      displayName: new FormControl('', [Validators.required]),
      email: new FormControl(''),
      userName: new FormControl(''),
    });
    this.formGroup1 = new FormGroup({
      oldPassword: new FormControl('', [Validators.required]),
      newPassword: new FormControl('', [Validators.required]),
      confirmPassword: new FormControl('', [Validators.required]),
    });
    this.invalid = this.formGroup.invalid;
    this.invalid1 = this.formGroup1.valid;
    this.getUserInfo();
  }

  getUserInfo() {
    this.submitting = true;
    console.log(this.currentUser);
    this._userService.getById(this.currentUser.userId).then(async rs => {
      if (rs.success) {
        this.itemDetail = rs.data;
      }
      this.submitting = false;
    });
  }

  save() {
    this.submitting = true;
    if (this.formGroup.invalid) {
      this.showValidateMessage();
      this.submitting = false;
      return;
    }
    if (this.itemDetail.userId) {
      this.onUpdate();
    }
  }

  onUpdate() {
    this._baseService.put(this.itemDetail.userId.toString(), this.itemDetail)
      .then(rs => {
        if (rs.success) {
          this._notifierService.showUpdateDataSuccess();
          this.submitting = false;
        }
      }, error => {
        this._notifierService.showUpdateDataFailed();
        this.submitting = false;
      });
  }
  onChangePass() {
    if (this.itemDetail.newPassword !== this.itemDetail.confirmPassword) {
      this.formGroup1.controls['newPassword'].setErrors({ 'nomatch': true });
      this._notifierService.showError('Mật khẩu mới không khớp');
      this.formGroup1.setErrors({ 'invalid': true });
      this.invalid = true;
      this.showValidateMessage();
      return;
    }

    if (this.formGroup.invalid) {
      this.invalid = true;
      this.showValidateMessage();
      return;
    }
    this._userService.changePassword(this.itemDetail)
      .then(response => {
        this.closePopupMethod(true);
        this._notifierService.showUpdateDataSuccess();
        this.onAfterSave();
        this.submitting = false;
        this.formGroup1.reset();
      }, error => {
        console.log(error.error.error);
        if (error.error.error === 'PASSWORD_NOT_MATCHING') {
          this.invalid1 = true;
          this.formGroup1.controls['oldPassword'].setErrors({ 'incorrect': true });
          this.formGroup1.setErrors({ 'invalid': true });
          this._notifierService.showWarning('Mật khẩu cũ không đúng');
          this.showValidateMessage();

        } else {
          this._notifierService.showUpdateDataFailed();
        }
        this.submitting = false;
      });
  }

}
